import React, { Component, PropTypes } from 'react';
import { Col, Radio, Table } from 'react-bootstrap';

import { Collapse } from 'react-collapse';

class UnderwritingQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">
          <a style={{ cursor: 'pointer' }} onClick={() => this.setState({ open: !this.state.open })}>
            {this.state.open ? 'Underwriting Question ▲ ' : 'Underwriting Question ▼'}
          </a>
        </h3>
        <Collapse isOpened={this.state.open}>
        <Table responsive>
          <thead>
            <tr>
              <th colSpan="2" className="ebaoUtil__Text-Center">Please select Yes or No. If Yes, please provide details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="col-xs-6">On Driver - Have any of the named drivers ever been disqualified or accumulated more than 12 driving offence points in the last 24 months? If &quot;Yes&quot;, please give full details.</td>
              <td className="col-xs-6">
              <Col sm={6}>
                  <Radio
                    inline
                    name="question1"
                    value={false}
                    onChange={this.props.handleChangeUnderwritingQuestion}
                    checked={this.props.underwritingQuestion.q1.checked === false}
                    >No</Radio>
                  </Col>
                  <Col sm={6}>
                  <Radio
                      inline
                      name="question1"
                      value
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      checked={this.props.underwritingQuestion.q1.checked === true}
                      >Yes</Radio>
                      </Col>
                      <br />
                  <textarea
                      id="question1"
                      rows="6"
                      cols="50"
                      maxLength="4000"
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      value={this.props.underwritingQuestion.q1.details}
                    />
              </td>
            </tr>
            <tr>
              <td className="col-xs-6">On Driver - Have any of the named drivers made a motor claim in the last 3 years? If &quot;Yes&quot;, please give full details.</td>
              <td className="col-xs-6">
              <Col sm={6}>
                  <Radio
                    inline
                    name="question2"
                    value={false}
                    onChange={this.props.handleChangeUnderwritingQuestion}
                    checked={this.props.underwritingQuestion.q2.checked === false}
                    >No</Radio>
              </Col>
              <Col sm={6}>
                  <Radio
                      inline
                      name="question2"
                      value
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      checked={this.props.underwritingQuestion.q2.checked === true}
                      >Yes</Radio>
                </Col>
                      <br />
                  <textarea
                      id="question2"
                      rows="6"
                      cols="50"
                      maxLength="4000"
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      value={this.props.underwritingQuestion.q2.details}
                  />
              </td>
            </tr>
            <tr>
              <td className="col-xs-6">On Vehicle - Has the insured vehicles been illegally modified? If &quot;Yes&quot;, please specify.</td>
              <td className="col-xs-6">
              <Col sm={6}>
                  <Radio
                    inline
                    name="question3"
                    value={false}
                    onChange={this.props.handleChangeUnderwritingQuestion}
                    checked={this.props.underwritingQuestion.q3.checked === false}
                    >No</Radio>
              </Col>
              <Col sm={6}>
                  <Radio
                      inline
                      name="question3"
                      value
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      checked={this.props.underwritingQuestion.q3.checked === true}
                      >Yes</Radio>
              </Col>
                      <br />
                  <textarea
                      id="question3"
                      rows="6"
                      cols="50"
                      maxLength="4000"
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      value={this.props.underwritingQuestion.q3.details}
                  />
              </td>
            </tr>
            <tr>
              <td className="col-xs-6">On Vehicle - Is the car under a hire purchase agreement? (An extra copy of the policy will be sent to you for forwarding to your hire purchase company) If &quot;Yes&quot;, please state the amount of the hire purchase owner company and the outstanding loan amount.</td>
              <td className="col-xs-6">
              <Col sm={6}>
                  <Radio
                    inline
                    name="question4"
                    value={false}
                    onChange={this.props.handleChangeUnderwritingQuestion}
                    checked={this.props.underwritingQuestion.q4.checked === false}
                    >No</Radio>
              </Col>
              <Col sm={6}>
                  <Radio
                      inline
                      name="question4"
                      value
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      checked={this.props.underwritingQuestion.q4.checked === true}
                      >Yes</Radio>
              </Col>
                      <br />
                  <textarea
                      id="question4"
                      rows="6"
                      cols="50"
                      maxLength="4000"
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      value={this.props.underwritingQuestion.q4.details}
                  />
              </td>
            </tr>
            <tr>
              <td className="col-xs-6">On Vehicle - Will passengers or goods be carried for hire or reward? If &quot;Yes&quot;, please specify.</td>
              <td className="col-xs-6">
                <Col sm={6}>
                  <Radio
                    inline
                    name="question5"
                    value={false}
                    onChange={this.props.handleChangeUnderwritingQuestion}
                    checked={this.props.underwritingQuestion.q5.checked === false}
                    >No</Radio>
                </Col>
                <Col sm={6}>
                  <Radio
                      inline
                      name="question5"
                      value
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      checked={this.props.underwritingQuestion.q5.checked === true}
                      >Yes</Radio>
                </Col>
                      <br />
                  <textarea
                      id="question5"
                      rows="6"
                      cols="50"
                      maxLength="4000"
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      value={this.props.underwritingQuestion.q5.details}
                  />
              </td>
            </tr>
            <tr>
              <td className="col-xs-6">On Vehicle - Has any theft alarm system been installed in the car?</td>
              <td className="col-xs-6">
                <Col sm={6}>
                  <Radio
                    inline
                    name="question6"
                    value={false}
                    onChange={this.props.handleChangeUnderwritingQuestion}
                    checked={this.props.underwritingQuestion.q6.checked === false}
                    >No</Radio>
                </Col>
                <Col sm={6}>
                  <Radio
                      inline
                      name="question6"
                      value
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      checked={this.props.underwritingQuestion.q6.checked === true}
                      >Yes</Radio>
                  </Col>
                      <br />
                  <textarea
                      id="question6"
                      rows="6"
                      cols="50"
                      maxLength="4000"
                      onChange={this.props.handleChangeUnderwritingQuestion}
                      value={this.props.underwritingQuestion.q6.details}
                  />
              </td>
            </tr>
          </tbody>
          </Table>
        </Collapse>
      </div>
    )
  }
}

UnderwritingQuestion.propTypes = {
  handleChangeUnderwritingQuestion: PropTypes.func,
  underwritingQuestion: PropTypes.object
};

export default UnderwritingQuestion;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/underwritingQuestion/UnderwritingQuestion.js